import React, {useState, useEffect, useContext} from 'react'
import {
  Container,
  Button,
  Grid,
  Typography,
  Box,
  MenuItem,
  Card,
  TextField,
  Drawer,
} from '@material-ui/core'
import step1Image from '../../assets/images/BG_Wizard_Step1.png'
import step2Image from '../../assets/images/BG_Wizard_Step2.png'
import step3Image from '../../assets/images/BG_Wizard_Step3.png'
import bgArrow from '../../assets/images/BG_arrow.png'
import {Query} from 'react-apollo'
import {barcodeSheetQuery} from '../../graphql/barcode/queries/barcodeSheetQuery'
import {Link} from 'react-router-dom'
import BarcodeNavHeaderButtons from '../BarcodeNavHeaderButtons'
import BarcodeCreateSheet from '../BarcodeCreateSheet'
import {useTranslation} from 'react-i18next'
import useStyles from './BarcodeWizardPage.styles'
import BarcodeLoadingScreen from '../BarcodeLoadingScreen'
import {BarcodeUrlSkipContext} from '../../context/BarcodeUrlSkip'
import BarcodeWizardPreview from '../BarcodeWizardPreview'
import {BarcodeLabelRecordContext} from '../../context/BarcodeLabelRecord'
import {BarcodeSheetRecordContext} from '../../context/BarcodeSheetRecord'
import {BarcodeWizardContext} from '../../context/BarcodeWizard'
import {ToastMessageContext} from '../../context/ToastMessage'
import {UserContext} from '../../context/UserContext'
import {validateBarcodePermission} from '../../modules/common/utils/permissions'

function BarcodeWizardPage(props) {
  const classes = useStyles()
  const {t} = useTranslation()
  const accountID = parseInt(window.localStorage.getItem('account_id'))
  const {barcodeSheetRecord} = useContext(BarcodeSheetRecordContext)
  const {barcodeLabelRecord} = useContext(BarcodeLabelRecordContext)

  const [sheetValue, setSheetValue] = useState(barcodeSheetRecord || '')
  const [labelValue, setLabelValue] = useState(barcodeLabelRecord || '')
  const [drawerOpen, setDrawerOpen] = useState(false)
  const [createData, setCreateData] = useState(undefined)
  const {urlGoTo} = useContext(BarcodeUrlSkipContext)
  const {setBarcodeLabelRecord} = useContext(BarcodeLabelRecordContext)
  const {setBarcodeSheetRecord} = useContext(BarcodeSheetRecordContext)
  const currentUser = React.useContext(UserContext)

  const {setAutoGenerateFormValues, setGenerateFormValue, createdBarcodeLabel} = useContext(
    BarcodeWizardContext
  )
  const toast = useContext(ToastMessageContext)

  const [errors, setErrors] = useState({
    sheet: null,
    label: null,
  })

  useEffect(() => {
    setAutoGenerateFormValues(null)
    setGenerateFormValue(null)
    if (createData) {
      setLabelValue('')
      setBarcodeLabelRecord('')
      setBarcodeSheetRecord(createData)
    } else if (drawerOpen) {
      if (window !== window.parent) {
        window.parent.postMessage('scrollTop', process.env.REACT_APP_BARCODE_WINDOW_URL)
      } else {
        window.scrollTo(0, 0)
      }
    }
  }, [
    createData,
    drawerOpen,
    setBarcodeLabelRecord,
    setBarcodeSheetRecord,
    setAutoGenerateFormValues,
    setGenerateFormValue,
  ])

  function sheetChange(event) {
    if (!!errors.sheet) {
      setErrors({...errors, sheet: null})
    }
    setSheetValue(event.target.value)
    setLabelValue('')
    setBarcodeLabelRecord('')
    setBarcodeSheetRecord(event.target.value)
    setCreateData(undefined)
  }

  function labelChange(event) {
    setLabelValue(event.target.value)
    setBarcodeLabelRecord(event.target.value)
  }

  function clickContinue(event) {
    if(!validateBarcodePermission(currentUser, "can_add")){
      return;
    }
    if (!sheetValue || !labelValue) {
      toast.popMessage(
        t('barcode.wizard.wizard-page.select-to-continue'),
        'warning',
        event.currentTarget
      )
    } else {
      if (urlGoTo) {
        props.history.push({
          pathname: urlGoTo,
        })
      } else {
        props.history.push({
          pathname: 'barcode-wizard-generate-setting',
        })
      }
    }
  }

  function labelMenu(labelData) {
    let hasLabels = []
    if (labelData === undefined || labelData.length === 0) {
      return (
        <MenuItem value="" disabled>
          {t('barcode.wizard.wizard-page.no-labels')}
        </MenuItem>
      )
    } else {
      labelData.map(barcodeLabel => {
        if (barcodeLabel['accountId'] === accountID) {
          hasLabels.push(
            <MenuItem key={barcodeLabel.id} value={barcodeLabel}>
              {barcodeLabelRecord &&
                barcodeLabelRecord.id === barcodeLabel.id &&
                setLabelValue(barcodeLabel)}
              {barcodeLabel.name}
            </MenuItem>
          )
        }
        return hasLabels
      })
      if (hasLabels.length > 0) {
        return hasLabels
      } else {
        return (
          <MenuItem value="" disabled>
            {t('barcode.wizard.wizard-page.no-labels')}
          </MenuItem>
        )
      }
    }
  }

  const toggleDrawer = open => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }

    setDrawerOpen(open)
  }

  function selectSheetCreate(sheet) {
    setCreateData(sheet)
  }

  function onLabelCreateSetSheetValue(sheet) {
    setSheetValue(sheet)
    let label = sheet.labels.find(obj => obj.name === barcodeLabelRecord.name)
    if (label) {
      setBarcodeLabelRecord(label)
      setLabelValue(label)
    }
  }

  return (
    <div>
      <BarcodeNavHeaderButtons previous="" />
      <Query query={barcodeSheetQuery} variables={{accountId: accountID}}>
        {({loading, error, data}) => {
          if (loading) {
            return (
              <div>
                <BarcodeLoadingScreen size={50} />
              </div>
            )
          }

          if (error) {
            return (
              <div>
                {props.history.push({
                  pathname: 'pageNotFound',
                })}
              </div>
            )
          }

          return (
            <div>
              <Grid container>
                <Grid item xs={6}>
                  <div>                    
                    <Typography variant="h6" className={classes.headerTitle}>
                      {t('barcode.wizard.wizard-page.simplest-way')}
                    </Typography>
                  </div>
                  <Container>
                    <Grid container>
                      <Grid item xs className={classes.imageCenter}>
                        <img src={step1Image} alt="Step 1 Display" />
                        <Box textAlign="center" fontSize={12} fontWeight="light" marginTop={2}>
                          {t('barcode.wizard.wizard-page.choose-sheet')}
                        </Box>
                      </Grid>
                      <Grid item xs={1} className={classes.arrowMargin}>
                        <img src={bgArrow} alt="arrow" />
                      </Grid>

                      <Grid item xs className={classes.imageCenter}>
                        <img
                          src={step2Image}
                          className={[classes.image, classes.libraryBG].join(' ')}
                          alt="Step 2 Display"
                        />
                        <Box textAlign="center" fontSize={12} fontWeight="light" marginTop={2}>
                          {t('barcode.wizard.wizard-page.choose-label')}
                        </Box>
                      </Grid>
                      <Grid item xs={1} className={classes.arrowMargin}>
                        <img src={bgArrow} alt="arrow" />
                      </Grid>

                      <Grid item xs className={classes.imageCenter}>
                        <img
                          src={step3Image}
                          className={[classes.image, classes.libraryBG].join(' ')}
                          alt="Step 3 Display"
                        />
                        <Box textAlign="center" fontSize={12} fontWeight="light" marginTop={2}>
                          {t('barcode.wizard.wizard-page.generate-pdf')}
                        </Box>
                      </Grid>
                    </Grid>

                    <Typography variant="h6">
                      <Box marginTop={8} marginBottom={2}>
                        {t('barcode.wizard.wizard-page.choose-sheet-1')}
                      </Box>
                    </Typography>

                    <Grid container>
                      <Grid container item xs={6} justify="flex-start">
                        <TextField
                          id="outlined-select-sheet"
                          select
                          label={t('barcode.wizard.wizard-page.select-sheet')}
                          className={classes.menuBar}
                          value={sheetValue}
                          fullWidth={true}
                          onChange={sheetChange}
                          SelectProps={{
                            MenuProps: {
                              getContentAnchorEl: null,
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                            },
                          }}
                          variant="outlined"
                        >
                          {data.barcodeSheet.map(barcodeSheet => (
                            <MenuItem key={barcodeSheet.id} value={barcodeSheet}>
                              {createData &&
                                createData.id === barcodeSheet.id &&
                                setSheetValue(barcodeSheet)}
                              {barcodeSheetRecord &&
                                barcodeSheetRecord.id === barcodeSheet.id &&
                                setSheetValue(barcodeSheet)}
                              {createdBarcodeLabel &&
                                barcodeLabelRecord &&
                                !barcodeLabelRecord.id &&
                                barcodeLabelRecord.sheet.id === barcodeSheet.id &&
                                onLabelCreateSetSheetValue(barcodeSheet)}
                              {barcodeSheet.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      {validateBarcodePermission(currentUser, "can_add") &&
                        <>
                          <Grid container item xs={3} justify="center" alignItems="center">
                            <Typography variant="h6">{t('barcode.wizard.wizard-page.or')}</Typography>
                          </Grid>

                          <Grid container item xs={3} justify="flex-start">
                            <Button
                              variant="outlined"
                              color="primary"
                              className={classes.buttonCreate}
                              onClick={toggleDrawer(true)}
                            >
                              {t('barcode.wizard.wizard-page.create-new')}
                            </Button>
                          </Grid>
                        </>
                      }
                    </Grid>

                    <Typography variant="h6">
                      <Box marginTop={5} marginBottom={2}>
                        {t('barcode.wizard.wizard-page.choose-label-2')}
                      </Box>
                    </Typography>

                    <Grid container>
                      <Grid container item xs={6} justify="flex-start">
                        <TextField
                          id="outlined-select-currency"
                          select
                          label={t('barcode.wizard.wizard-page.select-label')}
                          className={classes.menuBar}
                          value={labelValue}
                          fullWidth={true}
                          onChange={labelChange}
                          SelectProps={{
                            MenuProps: {
                              getContentAnchorEl: null,
                              anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'left',
                              },
                            },
                          }}
                          variant="outlined"
                        >
                          {labelMenu(sheetValue.labels)}
                        </TextField>
                      </Grid>

                      {validateBarcodePermission(currentUser, "can_add") &&
                        <>
                          <Grid container item xs={3} justify="center" alignItems="center">
                            <Typography variant="h6">{t('barcode.wizard.wizard-page.or')}</Typography>
                          </Grid>

                          <Grid container item xs={3} justify="flex-start">
                            <Button
                              variant="outlined"
                              color="primary"
                              className={classes.buttonCreate}
                              to="/new-label"
                              component={Link}
                            >
                              {t('barcode.wizard.wizard-page.create-new')}
                            </Button>
                          </Grid>
                        </>}                     
                    </Grid>

                    <Card className={classes.infoBackground}>
                      <Box margin={(3, 5, 2)} fontSize={13} fontWeight="bold">
                        {t('barcode.wizard.wizard-page.click-continue')}
                      </Box>
                    </Card>

                    <Grid container justify="flex-end">
                      <Button
                        variant="contained"
                        color="primary"
                        disabled = {!validateBarcodePermission(currentUser, "can_add")}
                        onClick={clickContinue}
                        className={classes.btnTextTransfrom}
                      >
                        {t('barcode.wizard.wizard-page.continue')}
                      </Button>
                    </Grid>
                  </Container>
                </Grid>

                <Grid container item xs={6}>
                  <BarcodeWizardPreview />
                </Grid>
              </Grid>
            </div>
          )
        }}
      </Query>
      <Drawer anchor="right" open={drawerOpen}>
        <BarcodeCreateSheet
          toggleDrawer={toggleDrawer()}
          accountId={accountID}
          selectSheetCreate={selectSheetCreate}
        />
      </Drawer>
    </div>
  )
}

export default BarcodeWizardPage
